import Form from './components/form_controller';

export default class UsersFiltersController extends Form {
  dropdownIds = ['roles', 'status', 'per_page'];
}
